import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALMASTER,
  DELETE_LEGALMASTER,
  UPDATE_LEGALMASTER,
  ADD_NEW_LEGALMASTER,
} from "./actionType";

import {
  getLegalMasterSuccess,
  getLegalMasterFail,
  deleteLegalMasterSuccess,
  deleteLegalMasterFail,
  updateLegalMasterSuccess,
  updateLegalMasterFail,
  addLegalMasterSuccess,
  addLegalMasterFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveLegalMasterApi,
  getLegalMasterApi,
  updateLegalMasterApi,
  deleteLegalMasterApi,
  addNewLegalMasterApi
} from "../../helpers/backend_helper";

function* getLegalMaster({ payload: legalMaster }) {
  try {
    const response = yield call(getLegalMasterApi, legalMaster);
    yield put(getLegalMasterSuccess(GET_LEGALMASTER, response.data));
  } catch (error) {
    yield put(getLegalMasterFail(GET_LEGALMASTER, error));
  }
}

function* onUpdateLegalMaster({ payload: legalMaster }) {
  try {
    if (legalMaster.setApprove) {
      const response = yield call(approveLegalMasterApi, legalMaster);
      yield put(updateLegalMasterSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateLegalMasterApi, legalMaster);
      yield put(updateLegalMasterSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateLegalMasterFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalMaster({ payload: legalMaster }) {
  try {
    const response = yield call(deleteLegalMasterApi, legalMaster);
    yield put(deleteLegalMasterSuccess({ legalMaster, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalMasterFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalMaster({ payload: legalMaster }) {
  try {
    const response = yield call(addNewLegalMasterApi, legalMaster);
    yield put(addLegalMasterSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalMasterFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalMaster() {
  yield takeEvery(GET_LEGALMASTER, getLegalMaster);
}

export function* watchUpdateLegalMaster() {
  yield takeEvery(UPDATE_LEGALMASTER, onUpdateLegalMaster);
}

export function* watchDeleteLegalMaster() {
  yield takeEvery(DELETE_LEGALMASTER, onDeleteLegalMaster);
}

export function* watchAddNewLegalMaster() {
  yield takeEvery(ADD_NEW_LEGALMASTER, onAddNewLegalMaster);
}

function* legalMasterSaga() {
  yield all([
    fork(watchGetLegalMaster),
    fork(watchDeleteLegalMaster),
    fork(watchUpdateLegalMaster),
    fork(watchAddNewLegalMaster)
  ]);
}

export default legalMasterSaga;
